import { useState } from "react";
import SeatType from "./SeatType"; // импортируем новую страницу

const SeatCategory = () => {
  const [selected, setSelected] = useState(null);

  const handleSelect = (type) => {
    setSelected(type);
  };

  return (
    <div className="flex flex-col items-center border-t w-full justify-center px-4 py-12 transition-all">
      <h2 className="text-2xl font-bold mb-12 text-center">Select Seat Category</h2>

      <div className="flex gap-12">
        {/* Family */}
        <div
          className="text-center cursor-pointer"
          onClick={() => handleSelect("family")}
        >
          <div className="flex justify-center mb-4">
            <img
              src={selected === "family" ? "/g3.png" : "/g1.png"}
              alt="Family"
              className="h-24 w-auto transition"
            />
          </div>
          <p
            className={`text-lg font-medium ${
              selected === "family" ? "text-black" : "text-gray-400"
            }`}
          >
            Family
          </p>
        </div>

        {/* General */}
        <div
          className="text-center cursor-pointer"
          onClick={() => handleSelect("general")}
        >
          <div className="flex justify-center mb-4">
            <img
              src={selected === "general" ? "/g4.png" : "/g2.png"}
              alt="General"
              className="h-24 w-auto transition"
            />
          </div>
          <p
            className={`text-lg font-medium ${
              selected === "general" ? "text-black" : "text-gray-400"
            }`}
          >
            General
          </p>
        </div>
      </div>

      {/* Плавное появление блока SeatType */}
      <div
        className={`transition-all duration-500 ease-in-out ${
          selected ? "opacity-100 translate-y-0 mt-12" : "opacity-0 -translate-y-6 h-0 overflow-hidden"
        }`}
      >
        {selected && <SeatType seatCategory={selected} />}
      </div>
    </div>
  );
};

export default SeatCategory;
